import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MMU_GLOBAL_PRIVACY_CONTROL } from '../../injection-tokens/mmu-global-privacy-control.token';
import { MMU_SUBSIDIARY_COOKIE_NAME } from '../../injection-tokens/mmu-subsidiary-cookie-name.token';


@Component({
  selector: 'mmu-global-privacy-control-hint',
  templateUrl: './mmu-global-privacy-control-hint.component.html'
})
export class MmuGlobalPrivacyControlHintComponent implements OnInit {
  showGPCHint = false;

  private readonly gpcRequiredSubsidiaries = ['us'];

  @Output()
  disableAnalyticsCookies = new EventEmitter<boolean>();

  constructor(
    @Inject(MMU_GLOBAL_PRIVACY_CONTROL) private gpcToken: boolean,
    @Inject(MMU_SUBSIDIARY_COOKIE_NAME) private readonly subsidiaryCookieName: string,
    private cookieService: CookieService
  ) {
  }

  ngOnInit(): void {
    const gpcHintToBeShown = this.gpcRequiredSubsidiaries.includes(this.cookieService.get(this.subsidiaryCookieName));

    this.showGPCHint = gpcHintToBeShown;

    if (gpcHintToBeShown && this.gpcToken == true) {
      this.disableAnalyticsCookies.emit(true);
    }
  }
}
